import * as React from 'react';
import OrderDetailsError from '../order-details-error';
import TConnectOrderDetails from './components/tcon-order-details';
import MobilityPexOrderDetails from './components/mpex-order-details';

const OrderDetailsContainer = ({
  orderNumber,
  cidn,
  isMpexOrder,
  isStaffUser,
}: {
  orderNumber: string;
  cidn: string;
  isMpexOrder: boolean;
  isStaffUser: boolean;
}) => {
  return (
    <React.Fragment>
      {!isMpexOrder ? (
        <TConnectOrderDetails orderNumber={orderNumber} />
      ) : !isStaffUser ? (
        <MobilityPexOrderDetails orderNumber={orderNumber} cidn={cidn} />
      ) : (
        <OrderDetailsError />
      )}
    </React.Fragment>
  );
};

export default OrderDetailsContainer;
